// Lightweight i18n for Velixa Health — hero / services / contact strings.
import React, { createContext, useContext, useEffect, useState } from "react";

export const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "bn", label: "বাংলা" },
];

const DICT = {
  "hero.h1a": { en: "Hospital-quality nursing care,", hi: "अस्पताल-स्तर की नर्सिंग देखभाल,", kn: "ಆಸ್ಪತ್ರೆ-ಗುಣಮಟ್ಟದ ನರ್ಸಿಂಗ್ ಆರೈಕೆ,", bn: "হাসপাতাল-মানের নার্সিং সেবা," },
  "hero.h1b": { en: "right at home in Bangalore.", hi: "बेंगलुरु में आपके घर पर।", kn: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ನಿಮ್ಮ ಮನೆಯಲ್ಲೇ.", bn: "ব্যাঙ্গালোরে আপনার বাড়িতেই।" },
  "hero.sub": {
    en: "Trained nurses and caretakers for your loved ones — led by nurses from Manipal Hospitals. Available 24/7.",
    hi: "अपने प्रियजनों के लिए प्रशिक्षित नर्स और केयरटेकर — मणिपाल अस्पताल की नर्सों के नेतृत्व में। 24/7 उपलब्ध।",
    kn: "ನಿಮ್ಮ ಪ್ರಿಯಜನರಿಗೆ ತರಬೇತು ಪಡೆದ ನರ್ಸ್‌ಗಳು ಮತ್ತು ಕೇರ್‌ಟೇಕರ್‌ಗಳು — ಮಣಿಪಾಲ್ ಆಸ್ಪತ್ರೆಯ ನರ್ಸ್‌ಗಳ ನೇತೃತ್ವದಲ್ಲಿ. 24/7 ಲಭ್ಯ.",
    bn: "আপনার প্রিয়জনদের জন্য প্রশিক্ষিত নার্স ও কেয়ারটেকার — মণিপাল হাসপাতালের নার্সদের নেতৃত্বে। ২৪/৭ উপলব্ধ।",
  },
  "cta.book_wa": { en: "Book on WhatsApp", hi: "WhatsApp पर बुक करें", kn: "WhatsApp ನಲ್ಲಿ ಬುಕ್ ಮಾಡಿ", bn: "WhatsApp-এ বুক করুন" },
  "cta.call_now": { en: "Call Now", hi: "कॉल करें", kn: "ಈಗ ಕರೆ ಮಾಡಿ", bn: "এখনই কল করুন" },
  "cta.whatsapp_us": { en: "WhatsApp Us", hi: "WhatsApp करें", kn: "WhatsApp ಮಾಡಿ", bn: "WhatsApp করুন" },
  "hero.what_need": { en: "What do you need?", hi: "आपको क्या चाहिए?", kn: "ನಿಮಗೆ ಏನು ಬೇಕು?", bn: "আপনার কী প্রয়োজন?" },
  "services.h2": { en: "Our services", hi: "हमारी सेवाएं", kn: "ನಮ್ಮ ಸೇವೆಗಳು", bn: "আমাদের সেবাসমূহ" },
  "services.sub": {
    en: "18 services, one phone number. Tap any card to chat on WhatsApp — we'll confirm availability and share a personalised quote.",
    hi: "18 सेवाएं, एक फ़ोन नंबर। किसी भी कार्ड पर टैप करें — हम उपलब्धता और व्यक्तिगत कोटेशन साझा करेंगे।",
    kn: "18 ಸೇವೆಗಳು, ಒಂದು ಫೋನ್ ಸಂಖ್ಯೆ. ಯಾವುದೇ ಕಾರ್ಡ್‌ಅನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ — ನಾವು ಉಪಲಬ್ಧತೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಕೊಟೇಶನ್ ಹಂಚಿಕೊಳ್ಳುತ್ತೇವೆ.",
    bn: "১৮টি সেবা, একটি ফোন নম্বর। যেকোনো কার্ডে ট্যাপ করুন — আমরা উপলব্ধতা ও কাস্টমাইজ কোটেশন জানাব।",
  },
  "contact.h2a": { en: "Need home healthcare in Bangalore?", hi: "बेंगलुरु में होम हेल्थकेयर चाहिए?", kn: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ಹೋಮ್ ಹೆಲ್ತ್‌ಕೇರ್ ಬೇಕೇ?", bn: "ব্যাঙ্গালোরে হোম হেলথকেয়ার দরকার?" },
  "contact.sub": {
    en: "Share a few details — we'll call you back, usually within minutes.",
    hi: "कुछ विवरण साझा करें — हम आपको कुछ ही मिनटों में वापस कॉल करेंगे।",
    kn: "ಕೆಲವು ವಿವರಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ — ನಾವು ಕೆಲವೇ ನಿಮಿಷಗಳಲ್ಲಿ ಮರಳಿ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
    bn: "কিছু তথ্য শেয়ার করুন — আমরা কয়েক মিনিটের মধ্যে কল ব্যাক করব।",
  },
  "contact.request_cb": { en: "Request a Call Back", hi: "कॉल बैक का अनुरोध करें", kn: "ಕಾಲ್ ಬ್ಯಾಕ್ ವಿನಂತಿಸಿ", bn: "কল ব্যাক-এর অনুরোধ করুন" },
  "contact.send_wa": { en: "Send on WhatsApp", hi: "WhatsApp पर भेजें", kn: "WhatsApp ನಲ್ಲಿ ಕಳುಹಿಸಿ", bn: "WhatsApp-এ পাঠান" },
};

const Ctx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("velixa_lang") || "en"; } catch { return "en"; }
  });
  useEffect(() => { try { localStorage.setItem("velixa_lang", lang); } catch {} document.documentElement.lang = lang; }, [lang]);
  const t = (key) => (DICT[key]?.[lang] ?? DICT[key]?.en ?? key);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
